import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2 } from "lucide-react";
import { http, formatApiError } from "@/lib/api";

const SYMBOL = { NGN: "₦", USD: "$", GBP: "£", EUR: "€", CAD: "C$" };
const MARKET = { all: "Local & international", local: "Local only", international: "International only" };

export const AlertsPanel = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { http.get("/alerts").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const remove = async (id) => {
    try {
      await http.delete(`/alerts/${id}`);
      setItems((xs) => xs.filter((x) => x.id !== id));
      toast.success("Subscriber removed");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  if (!items) return <p className="text-gw-ground/70">Loading...</p>;
  const confirmed = items.filter((a) => a.confirmed).length;
  return (
    <div data-testid="admin-alerts-panel">
      <p className="text-gw-ground/80 mb-6" data-testid="admin-alerts-summary">
        {confirmed} confirmed subscriber{confirmed === 1 ? "" : "s"} · {items.length - confirmed} waiting to confirm. Confirmed subscribers are emailed automatically when you add a matching property.
      </p>
      {items.length === 0 ? (
        <p className="py-10 text-gw-ground/70" data-testid="admin-alerts-empty">No one has signed up for listing alerts yet.</p>
      ) : (
        <div className="overflow-x-auto border-t border-gw-ground/20">
          <table className="w-full text-sm" data-testid="admin-alerts-table">
            <thead>
              <tr className="lab text-[10px] text-gw-ground/70 text-left">
                {["Email", "Area", "Max budget", "Beds", "Market", "Status", "Signed up", ""].map((h) => <th key={h} className="py-3 pr-4 font-normal">{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {items.map((a, i) => (
                <tr key={a.id} className="border-t border-gw-ground/15" data-testid={`admin-alert-row-${i}`}>
                  <td className="py-3 pr-4"><a href={`mailto:${a.email}`} className="underline underline-offset-2">{a.email}</a></td>
                  <td className="py-3 pr-4">{a.area || "Any"}</td>
                  <td className="py-3 pr-4">{a.max_budget ? `${SYMBOL[a.currency]}${Number(a.max_budget).toLocaleString()}` : "No limit"}</td>
                  <td className="py-3 pr-4">{a.min_beds ? `${a.min_beds}+` : "Any"}</td>
                  <td className="py-3 pr-4">{MARKET[a.market] || a.market}</td>
                  <td className="py-3 pr-4">
                    <span className={`lab text-[10px] px-2 py-0.5 ${a.confirmed ? "bg-gw-ground text-white" : "bg-amber-50 text-amber-800 border border-amber-200"}`}>
                      {a.confirmed ? "Confirmed" : "Not confirmed"}
                    </span>
                  </td>
                  <td className="py-3 pr-4 whitespace-nowrap">{new Date(a.created_at).toLocaleDateString()}</td>
                  <td className="py-3 flex gap-2 justify-end">
                    <a href={`mailto:${a.email}`} aria-label="Email" className="p-2 border border-gw-ground/20 hover:bg-gw-tint" data-testid={`admin-alert-email-${i}`}><Mail size={14} /></a>
                    <button type="button" aria-label="Remove" onClick={() => remove(a.id)} className="p-2 border border-gw-ground/20 text-destructive hover:bg-red-50" data-testid={`admin-alert-delete-${i}`}><Trash2 size={14} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
